import { setTokenAction } from "@tshio/redux-api-auth-middleware";
import { setOAuthData, refreshTokenAction } from "../../actions/oauth";
import { SCOPE } from "../../constants/constants";
import WebSocketConnection from "../Websocket/Websocket";

class OAuthHandler {
  constructor(store) {
    this.store = store;
    this.webSocketConnection = WebSocketConnection.getInstance();
    const refreshToken = localStorage.getItem("refresh_token");
    const rights = localStorage.getItem("rights");
    if (refreshToken !== null && rights !== null) {
      setTimeout(() => {
        this.store.dispatch(refreshTokenAction(refreshToken, rights));
      }, 100);
    }
  }

  static logout = () => {
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("rights");
  };

  storeTokenData(tokenData) {
    const decoded = JSON.parse(atob(tokenData.access_token.split(".")[1]));
    const username = decoded.usr;
    const clientId = decoded.sub;
    const rights = decoded.rgt;
    this.store.dispatch(
      setTokenAction({
        access_token: tokenData.access_token,
        refresh_token: tokenData.refresh_token,
        expires_in: tokenData.expires_in,
      })
    );
    let right = "";
    const scopes = SCOPE.split(" ");
    rights
      .slice()
      .reverse()
      .forEach(key => {
        if (scopes.indexOf(key) > -1) {
          right += `${key} `;
        }
      });
    this.store.dispatch(setOAuthData(tokenData, username, clientId, rights));
    localStorage.setItem("refresh_token", tokenData.refresh_token);
    localStorage.setItem("rights", right.slice(0, -1));
    this.webSocketConnection.updateToken(tokenData.access_token);
    setTimeout(
      () => this.store.dispatch(refreshTokenAction(tokenData.refresh_token, right.slice(0, -1))),
      tokenData.expires_in * 1000 - 1000 * 120 // refresh token 2 minutes before expiration
    );
  }
}

const oAuthHandler = OAuthHandler;

export default oAuthHandler;
